<template>
  <div class="game-over-backdrop">
    <h2>Game Over</h2>
    <h3>Showing scores of all players</h3>
    <button class="button-35" v-if="showPlayAgain" @click="playAgain">
      PLAY AGAIN
    </button>
    <br />
    <UserList />
  </div>
</template>

<script>
  import * as socketio from '../plugins/socketio';
  import UserList from './UserList.vue';

  export default {
    components: { UserList },
    data() {
      return {
        player: '',
        playerName: '',
        customRoomId: '',
        showPlayAgain: false,
      };
    },
    mounted() {
      console.log('Game Over panel Mounted');
      socketio.sendEvent({
        type: 'whoAmI',
        // data: {socketId: socketio.clientSocketId()}
      });
      socketio.addEventListener({
        type: 'IAm',
        callback: ({ player, roomId }) => {
          this.player = player;
          this.playerName = player.playerName;
          this.customRoomId = roomId;
        },
      });
      setTimeout(() => {
        // show playagain button
        this.showPlayAgain = true;
        console.log('insta lock');
      }, 10000);
    },
    methods: {
      playAgain() {
        // just redirect them to the main page and let them start again
        window.location.replace('https://doodle-io.web.app/');
        // change to webpage url
        // window.location.replace('http://localhost:8080/');
      },
    },
  };
</script>

<style>
  .game-over-backdrop {
    top: 0;
    position: fixed;
    background: rgb(49, 180, 163);
    color: aliceblue;
    width: 100%;
    height: 100%;
  }
</style>
